<template>

  <div>
    <a
      :href="job.career_url"
      target="_blank"
      v-if="job.publicate === 'published'"
      class="btn btn-light">
      <i class="fas fa-globe-americas text-success" />
      {{ $t('Published') }}
      </a>
    <a
      :href="job.career_url"
      target="_blank"
      v-if="job.publicate === 'unlisted'"
      class="btn btn-light">
      <i class="fas fa-eye-slash text-primary" />
      {{ $t('Unlisted') }}
      </a>
    <div 
      v-if="job.publicate === 'internal'"
      class="btn btn-light">
      <i class="fas fa-home text-warning" />
      {{ $t('Internal') }}
      </div>
    <div 
      v-if="job.publicate === 'no'"
      class="btn btn-secondary">
      <i class="far fa-times-circle"></i>
      {{ $t('Not published') }}
      </div>
  </div>

</template>

<script>
export default {
  name: 'JobPublush',
  components: {
  },
  data () {
    return {
    }
  },
  computed: {
    job () {
      return this.$store.getters.getJob
    }
  },
  created () {
  },
  methods: {
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/Job/JobHeader/JobPublish.vue